angular
    .module('festzelt-os.modules.bo.objects', [
        'ui.router',
        'festzelt-os.components'
    ]);


require('./routes');

// Controllers
require('./controllers/create-controller');
require('./controllers/details-controller');
require('./controllers/edit-controller');
require('./controllers/list-controller');

// Factories
require('./factories/bookable-object-factory');
require('./store/objects');



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/module.js